import React, { useCallback } from "react";
import useDebouncedCallback from "@builder/hooks/useDebounceCallback";
import OliverText from "@builder/components/general/OliverText";
import { StreamLanguage } from "@codemirror/language";
import { css as legacyCSS } from "@codemirror/legacy-modes/mode/css";
import CodeMirror from "@uiw/react-codemirror";
import { useTranslation } from "react-i18next";
import "./style.scss";

interface CustomCSSProps {
  value?: string;
  callback: (value: string) => void;
}

const CustomCSS: React.FC<CustomCSSProps> = ({ value = "", callback }) => {
  const { t } = useTranslation();

  // Create a debounced version of the callback
  const debouncedCallback = useDebouncedCallback(callback, 1000);

  const handleChange = useCallback(
    (val: string) => {
      debouncedCallback(val);
    },
    [debouncedCallback]
  );

  return (
    <div className="custom-css-wrapper">
      <OliverText text={t("generalComponents.customCSS.Custom CSS")} size="xs" />
      <CodeMirror
        value={value}
        placeholder="background-color: black;"
        extensions={[StreamLanguage.define(legacyCSS)]}
        onChange={handleChange}
        basicSetup={{
          lineNumbers: false, // Optional: Hide line numbers if desired
        }}
      />
    </div>
  );
};

export default CustomCSS;
